export const points = [
  {
    name: "2x Ether.fi points",
    logo: "/points/ethfi.png",
    collateralVaults: ["0x10D0D11A8B693F4E3e33d09BBab7D4aFc3C03ef3"],
  },
  {
    name: "boosted rEUL if they are part of [turtle.club](https://turtle.club)",
    logo: "/points/turtle.png",
    isTurtleClub: true,
    skipValidation: true,
  },
] as const
